export default __webpack_public_path__ + "static/media/009.adc6bb8c.png";